<template>
  <div class="enterpriseTrend">
    <!-- top -->
    <div class="enterpriseTrend-top">
      <div class="enterpriseTrend-top-title">
        <span>企业统计</span>
        <!-- 提示帮助图标 -->
        <div class="attention">
          <div class="attention-model">
            <i></i>
            <ul>
              <li>
                <p>活跃企业数（今日）
                  <span>当天在客服系统中有登录帐号的企业数统计（剔重）</span>
                </p>
              </li>
              <li>
                <p>上线客服数（今日）
                  <span>当天在客服系统中有登录并进入客服模式的帐号数统计（剔重）</span>
                </p>
              </li>
              <li>
                <p>人工访客数（今日）
                  <span>当天进入人工客服的访客数（剔重）</span>
                </p>
              </li>
              <li>
                <p>人工会话量（今日）
                  <span>当天进入人工客服的会话数量</span>
                </p>
              </li>
              <li>
                <p>人工消息量（今日）
                  <span>当天进入人工客服状态后客服和访客发出的消息总数</span>

                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="enterpriseTrend-top-input">
        <!-- 日期选择器 -->
        <el-date-picker @change="dateRangeChange" v-model="datePickerModel" type="daterange" align="right" :placeholder="this.oldDateThirty +' - '+ this.newDate" :picker-options="DatePickerOptions">
        </el-date-picker>

        <!-- 导出excel表格 -->
        <a href="javascript:void(0)" class="derive" @click="deriveExcel"></a>
      </div>
    </div>
    <!-- content -->
    <div class="enterpriseTrend-content">
      <!-- tab拦 -->
      <ul class="tab-ls">
        <li v-for="(item,index) in todayDatas" :key="index" :class="{listActive:(listIsShowIndex == index)}" @click="listShowMd(index)">
          <p>{{item.tabName}}</p>
          <span>{{item.num}}</span>
          <i :class="{triangleActive:(listIsShowIndex == index)}"></i>
        </li>
      </ul>
      <!-- echart图表 -->
      <div class="enterpriseTrend-echart">
        <div id="charts">
          <div id="main"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@function p2r($size) {
  @return $size/16*1rem;
}

// top
.enterpriseTrend-top {
  display: flex;
  justify-content: space-between;
  height: 70px; // top的左边标题
  .enterpriseTrend-top-title {
    padding-left: p2r(18);
    height: 100%;
    position: relative;
    span {
      display: inline-block;
      padding-top: 23px;
      font-size: 18px;
      color: #666;
    }
    .attention {
      position: absolute;
      top: 28px;
      right: -26px;
      display: inline-block;
      width: 18px;
      height: 18px;
      background: url("../../statics/img/icon@2x.png") no-repeat 0 -729px;
      .attention-model {
        position: absolute;
        width: 600px;
        top: -20px;
        left: 50px;
        z-index: 2;
        background: rgba(0, 0, 0, .8);
        padding: 15px;
        box-sizing: border-box;
        border-radius: 10px;
        display: none;
        i {
          display: inline-block;
          width: 0;
          height: 0;
          border-top: 12px solid transparent;
          border-right: 24px solid rgba(0, 0, 0, .8);
          border-bottom: 12px solid transparent;
          position: absolute;
          left: -24px;
          top: 17px;
        }
        ul {
          li {
            p {
              color: #fff;
              padding: 10px;
              font-size: 14px;
              span {
                color: #fff;
                padding: 0;
                margin-left: 15px;
                font-size: 14px;
              }
            }
          }
        }
      }
      &:hover {
        .attention-model {
          display: block;
        }
      }
    }
  } // top右边的输入框
  .enterpriseTrend-top-input {
    margin-right: p2r(88);
    margin-top: 21px;
    position: relative;
    .derive {
      display: inline-block;
      width: 28px;
      height: 30px;
      background: url("../../statics/img/icon@2x.png") no-repeat -115px -805px;
      margin-top: 3px;
    } // 下拉框
    .el-date-editor {
      width: 205px;
      border-radius: 10px;
      margin-right: p2r(52);
      position: absolute;
      left: -257px;
      top: p2r(-2);
    }
  }
} // content
.enterpriseTrend-content {
  margin-right: 32px;
  display: flex;
  flex-direction: column; // tab拦
  .tab-ls {
    display: flex;
    justify-content: space-between;
    li {
      width: p2r(260);
      height: p2r(166);
      border: 1px solid #E5E5EB;
      font-size: 20px;
      text-align: center;
      cursor: pointer;
      position: relative;

      &.listActive {
        background: #EFF4F5;
      }
      p {
        padding-top: p2r(40);
        font-size: 20px;
        color: #333;
        padding-bottom: p2r(20);
      }
      span {
        font-family: "Montserrat-Regular";
        font-size: 48px;
        color: #263238;
        font-weight: 700;
      }
      i {
        position: absolute;
        bottom: -19px;
        left: p2r(118);
        width: 0;
        height: 0;
        border-left: 12px solid transparent;
        border-right: 12px solid transparent;
        border-top: 19px solid #EFF4F5;
        display: none;
        &.triangleActive {
          display: block;
        }
      }
    }
  } //echart图表
  .enterpriseTrend-echart {
    margin-top: 30px;
    #main {
      height: 31rem;
      border: 1px solid #E5E5EB;
      padding-bottom: 10px;
      margin-bottom: 5px;
      width: 100%;
      canvas {
        height: 400px;
      }
    }
  }
}
</style>

<script>
import echarts from "echarts";
// import deriveExcelMd from "../../common/deriveExcel.js";
import qs from 'qs';
export default {
  data() {
    return {
      //控制企业趋势tab拦的显示
      listIsShowIndex: 0,
      //当前日期&三十天前的日期&前一天的日期
      newDate: "",
      oldDateThirty: "",
      oldOneDate:"",
      //echart日期数组
      echartXay: [],
      //获取企业趋势总数据
      enterpriseTrendData: {},
      //echart图表入口
      myChart: "",
      DatePickerOptions: {
        shortcuts: [{
          text: '最近60天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近30天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近7天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      //绑定日期选择器
      datePickerModel: "",
      //tab栏的api
      tabListDatas: {},
      //tab栏数据
      todayDatas:[
        {
          tabName:"活跃企业数(今日)",
          num:0
        },
        {
          tabName:"上线客服数(今日)",
          num:0
        },
        {
          tabName:"人工访客数(今日)",
          num:0
        },
        {
          tabName:"人工会话量(今日)",
          num:0
        },
        {
          tabName:"人工消息量(今日)",
          num:0
        }
      ],
      startTime:"",
      endTime:"",
      //echart y轴最大值
      echartYMax:0
    }
  },
  mounted() {
    //初始化echart
    this.myChart = echarts.init(document.getElementById('main'));
    this.setChartYmax();
  },
  created() {
    //默认时间(默认显示一个月前)
    this.getThirtyDate();
    this.getCompanyTrendData(this.oldDateThirty, this.newDate);
    this.getTodayDatas();
  },
  methods: {
    //显示tab拦
    listShowMd(index) {
      this.listIsShowIndex = index;
      //根据索引渲染数据
      this.tabIfIndexShowData();
    },
    //设置下拉框默认显示时间和显示相应的数据
    dateRangeChange(val) {
      // console.log(val);
      if(val) {
        this.startTime = val.split(" ")[0];
        this.endTime = val.split(" ")[2];
        this.getCompanyTrendData(val.split(" ")[0], val.split(" ")[2]);
      }
    },
    //封装 获取统计数据
    getCompanyTrendData(startTime, endTime) {
      this.$ajax.post(
        "/api/company_stats",
        qs.stringify({ startTime: startTime, endTime: endTime })
      ).then(res => {
        this.echartXay = res.data.data.index;
        this.enterpriseTrendData = res.data.data;
        console.log("查看数据",res)
        //设置echart的日期显示
        const that_ls = this;
        this.myChart.setOption({
          xAxis: {
            data: that_ls.echartXay
          }

        });
        //根据索引渲染数据
        this.tabIfIndexShowData();
      })
    },
    //下拉框默认显示30天的时间
    getThirtyDate() {
      //当前时间
      const date = new Date();
      const day = date.getDate();
      const mon = date.getMonth() + 1;
      this.newDate = date.getFullYear() + "-" + (mon < 10 ? "0" + mon : mon) + "-" + (day < 10 ? "0" + day : day);

      //前一天
      const today = new Date(); 
      const yesterday = new Date();
      yesterday.setTime(today.getTime()-1000*60*60*24);
      const yesMon = yesterday.getMonth()+1; 
      const yesDay = yesterday.getDate();
      this.oldOneDate = yesterday.getFullYear() + "-" + (yesMon < 10 ? "0" + yesMon : yesMon) + "-" + (yesDay < 10 ? "0" + yesDay : yesDay);

      //一个月前的时间
      const DateThirty = new Date(date.getTime() - 30 * 24 * 3600 * 1000);
      const DateThirtyMonth = DateThirty.getMonth() + 1;
      const DateThirtyDay = DateThirty.getDate();
      this.oldDateThirty = DateThirty.getFullYear() + "-" +
        (DateThirtyMonth < 10 ? "0" + DateThirtyMonth : DateThirtyMonth) + "-" +
        (DateThirtyDay < 10 ? "0" + DateThirtyDay : DateThirtyDay);
    },
    //根据tab栏的索引来渲染相应的数据
    tabIfIndexShowData() {
      if (this.listIsShowIndex == 0) {
        //设置echart最大值
        this.echartYMax = Math.max.apply(null,this.enterpriseTrendData.active_num);
        this.setChartYmax();
        this.setChartDataShow(this.enterpriseTrendData.active_num, "#2abb9b","活跃企业数(今日)");

      } else if (this.listIsShowIndex == 1) {
        this.echartYMax = Math.max.apply(null,this.enterpriseTrendData.online_num);
        this.setChartYmax();
        this.setChartDataShow(this.enterpriseTrendData.online_num, "#a9e08b","上线客服数(今日)");

      } else if (this.listIsShowIndex == 2) {
        this.echartYMax = Math.max.apply(null,this.enterpriseTrendData.visitor_num);
        this.setChartYmax();
        this.setChartDataShow(this.enterpriseTrendData.visitor_num, "deepskyblue","人工访客数(今日)");

      } else if (this.listIsShowIndex == 3) {
        this.echartYMax = Math.max.apply(null,this.enterpriseTrendData.session_num);
        this.setChartYmax();
        this.setChartDataShow(this.enterpriseTrendData.session_num, "red","人工会话量(今日)");

      } else if (this.listIsShowIndex == 4) {
        this.echartYMax = Math.max.apply(null,this.enterpriseTrendData.msg_num);
        this.setChartYmax();
        this.setChartDataShow(this.enterpriseTrendData.msg_num, "orange","人工消息量(今日)");
      }
    },
    //设置echart的数据显示
    setChartDataShow(data, lineColor,dataName) {
      const that_ls = this;
      this.myChart.setOption({
        series: [
          {
            name: dataName,
            type: 'line',
            itemStyle: {
              normal: {
                lineStyle: {
                  color: lineColor
                }
              }
            },
            data: data
          }
        ]
      });
    },
    //设置echart y轴数据的最大值
    setChartYmax() {
      const that_ls = this;
      this.myChart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c}'
        },
        xAxis: {
          axisLine: {
            show: false,
            lineStyle: {
              color: '#98A4AD'
            }
          },
          axisTick: {
            show: false
          },
          type: 'category',
          splitLine: { show: false },
          data: that_ls.echartXay
        },
        grid: {
          left: '2%',
          right: '2%',
          bottom: '1%',
          y: 40,
          containLabel: true
        },
        yAxis: {
          axisLine: {
            show: false,
            lineStyle: {
              color: '#98A4AD'
            }
          },
          splitLine: {
            show: true
          },
          // 去除y轴上的刻度线
          axisTick: {
            show: false
          },
          type: 'value',
          splitNumber: 5,
          min: 0,
          max: that_ls.echartYMax
        }
      });
    },
    //导出excel表格
    deriveExcel() {
      this.$ajax.get(
        "/api/dump_stats",
        {
          params: {
            startTime:this.startTime || this.oldDateThirty,
            endTime:this.endTime || this.newDate
          }
        }
      ).then(res => {
          this.$downloadFile(res.data.data);
        })
    },
    //获取今日数据
    getTodayDatas() {
      this.$ajax.post(
        "/api/company_stats",
        qs.stringify({ startTime: this.oldOneDate, endTime: this.newDate }))
        .then(res => {
          // console.log(res);

          //处理今日数据
          this.tabListDatas = res.data.data;
          //数据保存到数组
          this.todayDatas[0].num = this.tabListDatas.active_num[1];
          this.todayDatas[1].num = this.tabListDatas.online_num[1];
          this.todayDatas[2].num = this.tabListDatas.visitor_num[1];
          this.todayDatas[3].num = this.tabListDatas.session_num[1];
          this.todayDatas[4].num = this.tabListDatas.msg_num[1];
        })
    }
  }
}


</script>



// WEBPACK FOOTER //
// enterpriseStatistics.vue?080ea8a9